import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createPinia } from "pinia";
const pinia = createPinia();
//公共组件
import publicComponents from "@/components/index.js";
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import "element-plus/dist/index.css";
import "./styles/common.scss";
import "@vant/touch-emulator";
import "vant/lib/index.css";
import {
  Picker,
  Popup,
  Tab,
  Tabs,
  Button,
  Loading,
  Search,
  DatePicker,
  Switch,
  Swipe,
  SwipeItem,
  Field,
  CellGroup,
  Toast,
  RadioGroup,
  Radio,
  Calendar,
  TreeSelect,
  TextEllipsis,
} from "vant";

//过滤器
import {
  formatDateTime,
  warrantydatekh,
  formatDateCn,
  formatDateYMD,
} from "@/util/filters.js";

//loading
import loading from "@/util/loading.js";

const app = createApp(App);

//注册ElementPlusIcons
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.config.globalProperties.$filters = {
  formatDateTime,
  formatDateCn,
  formatDateYMD,
  warrantydatekh,
};

app.config.globalProperties.$pcLoading = loading;

app.use(router);
app.use(ElementPlus, {
  locale: zhCn,
});
app.use(pinia);
app.use(publicComponents);
//vant
app.use(Picker);
app.use(Popup);
app.use(Tab);
app.use(Tabs);
app.use(Button);
app.use(Loading);
app.use(Search);
app.use(DatePicker);
app.use(Switch);
app.use(Swipe);
app.use(SwipeItem);
app.use(Field);
app.use(CellGroup);
app.use(Toast);
app.use(RadioGroup);
app.use(Radio);
app.use(Calendar);
app.use(TreeSelect);
app.use(TextEllipsis);
//挂载
app.mount("#app");
